import React from 'react';
interface DataBoxProps {
  title: React.ReactNode;
}

export const DataBox: React.SFC<DataBoxProps> = ({ title, children }) => (
  <div
    style={{
      border: '1px solid lightgrey',
      borderRadius: '1em',
      flex: 'auto',
      padding: '1em',
    }}
  >
    <h1 style={{ fontWeight: 600 }}>{title}</h1>
    <div style={{ height: 15 }} />
    {children}
  </div>
);
